module.exports = __webpack_public_path__ + "static/media/stripHalfCircleYellow1.d0e986a2.svg";